<template>
  <div id="app">
    <template v-if="!noLayout">
      <jm-header :site="siteName"/>
      <!-- 滚动通知 -->
      <jm-sidebar/>
      <!-- <transition name="el-fade-in"> -->
      <router-view/>
      <!-- </transition> -->
      <jm-footer/>
      <jm-returnPage/>
    </template>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import returnPage from './components/tool/returnPage';
import jmHeader from '@/components/common/header.vue';
import jmFooter from '@/components/common/footer.vue';
import sidebar from '@/components/tool/sidebar';
import sidebarEdu from '@/components/tool/sidebarEdu';
// import { getPlatformSource, isPhone } from '@/utils/utils';
// import lockr from 'lockr';
import './assets/js/scripts';
import dataset from '@/dataset';

// const sha256 = require('js-sha256').sha256;

export default {
  name: 'App',
  computed: {
    noLayout() {
      return Vue.prototype.$noLayout || false;
    },
    noAuth() {
      return Vue.prototype.$noAuth || false;
    },
    siteName() {
      return process.env.VUE_APP_SITE_NAME;
    }
  },
  components: {
    jmHeader,
    jmFooter,
    'jm-returnPage': returnPage,
    'jm-sidebar': process.env.VUE_APP_SITE_NAME === 'teaching' ? sidebarEdu : sidebar,
  },
  data() {
    return {
      // fetchStart: 0,
      // stateStr: '[state-status=true]',
      // stateKey: 'state-key',
      // biStr: {
      //   referrerUrl: 'bi-referrer-url',
      //   lastTime: 'bi-last-time',
      //   session: 'bi-session',
      //   diySession: 'bi-diy-session'
      // }
    };
  },
  methods: {
    // // 获取父级
    // getParentsKey(el, parentSelector) {
    //   if (parentSelector === undefined) {
    //     return '';
    //   }
    //   let parents = [];
    //   let p = el.parentNode;
    //   let key = '';
    //   while (p !== document) {
    //     let o = p;
    //     parents.push(o);
    //     key = o.getAttribute(this.stateKey);
    //     if (parentSelector.indexOf(key) > -1) {
    //       break;
    //     }
    //     p = o.parentNode;
    //   }
    //   return key;
    // },
    // // 客户端类型
    // terminal() {
    //   const source = getPlatformSource();
    //   switch (source) {
    //     case 'dingtalk':
    //       return 2;
    //     case 'wechat':
    //       return 3;
    //     case 'wework':
    //       return 4;
    //     default:
    //       return isPhone() ? 1 : 0;
    //   }
    // },
    // // 页面打点函数
    // sendPageBI(hasReferrer) {
    //   let fp = lockr.get(this.biStr.session);
    //   if (fp) {
    //     // 上一页
    //     let dr = hasReferrer ? lockr.get(this.biStr.referrerUrl) : '';
    //     // 当前页
    //     let turl = encodeURIComponent(this.urlEncode(window.location.href));
    //     if (dr === turl) {
    //       console.log('页面一致', turl);
    //       return true;
    //     }
    //     lockr.set(this.biStr.referrerUrl, turl);
    //     let timer = (new Date().getTime() / 1000) - this.fetchStart;
    //     this.$http._post({
    //       url: '/index/b_i/page',
    //       data: {
    //         url: turl,
    //         before_url: dr,
    //         load_timer: timer,
    //         terminal: this.terminal(),
    //         fp: fp,
    //         diysession: this.initDiySession()
    //       },
    //       config: {
    //         crossDomain: true,
    //       },
    //       success: function() {
    //         // 后期留作停留时间计算
    //         // bi_url_log_id = id;
    //       }
    //     });
    //   }
    // },
    // // 页面打点函数
    // sendButtonBI(key) {
    //   let fp = lockr.get(this.biStr.session);
    //   if (fp) {
    //     // 上一页
    //     let dr = encodeURIComponent(this.urlEncode(window.location.href));
    //     // 当前页
    //     let turl = encodeURIComponent(this.urlEncode(key));
    //     let timer = (new Date().getTime() / 1000) - this.fetchStart;
    //     this.$http._post({
    //       url: '/index/b_i/button',
    //       data: {
    //         url: turl,
    //         before_url: dr,
    //         load_timer: timer,
    //         terminal: this.terminal(),
    //         fp: fp,
    //         diysession: this.initDiySession()
    //       },
    //       config: {
    //         crossDomain: true,
    //       },
    //       success: function() {
    //       }
    //     });
    //   }
    // },
    // setFetchStart(time) {
    //   this.fetchStart = time;
    // },
    // urlEncode(text) {
    //   let val = text.replace('http://', '').replace('https://', '');
    //   return val;
    // },
    // initDiySession() {
    //   let newTime = (new Date()).getTime() / 1000;
    //   let oldTime = lockr.get(this.biStr.lastTime);
    //   let diysession = lockr.get(this.biStr.diySession);
    //   if (newTime - oldTime > 1800 || !diysession || !lockr.get('jwt') || sha256(lockr.get('jwt')) !== lockr.get(this.biStr.session)) {
    //     // 距离上一次操作超出30分钟后或者没有初始化diysession的或者前后session不一致时(换号登录)
    //     diysession = this.initNewDiySession(newTime);
    //   }
    //   lockr.set(this.biStr.lastTime, newTime);
    //   return diysession;
    // },
    // initNewDiySession(newTime = 0) {
    //   let jwt = lockr.get('jwt') ? sha256(lockr.get('jwt')) : '';
    //   if (jwt !== lockr.get(this.biStr.session)) {
    //     // 换号登陆了，需要去掉上一页信息
    //     lockr.set(this.biStr.referrerUrl, null);
    //   }
    //   lockr.set(this.biStr.session, jwt);
    //   newTime = sha256(jwt + newTime + this.terminal());
    //   lockr.set(this.biStr.diySession, newTime);
    //   return newTime;
    // }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.noAuth) {
        this.$store.dispatch('fetchDict');
      }
      this.$store.commit('setDatasetDict', dataset);
      this.$isOnline &&
        this.$el.addEventListener('copy', () => {
          const text = window.getSelection().toString();
          if (text && this.$route.name !== 'enterStarmap') {
            this.$http._post({
              url: '/index/api_base/logCopyData',
              data: {
                text
              }
            });
          }
        });
    });
  },
  beforeUpdate() {
    // this.setFetchStart(new Date().getTime() / 1000);
  },
  updated() {
    // this.initDiySession();
    // this.$nextTick(() => {
    //   // 页面跳转的时候添加页面打点
    //   this.sendPageBI(true);
    // });
  },
  created() {
    // let fp = lockr.get('jwt');
    // if (fp) {
    //   document.querySelector('body').addEventListener('click', (event) => {
    //     // 按钮打点
    //     let stateKeys = document.querySelectorAll(this.stateStr);
    //     if (stateKeys.length > 0) {
    //       stateKeys = Array.from(stateKeys).map((item) => {
    //         return item.getAttribute(this.stateKey);
    //       });
    //       let key = this.getParentsKey(event.target, stateKeys);
    //       if (key) {
    //         this.sendButtonBI(key);
    //       }
    //     }
    //     this.initDiySession();
    //   });
    // }
  }
};
</script>
